import React from 'react';
import styled from 'styled-components';
import { PageSlice } from '@contracts';
import Certifications from './design/Certifications';

interface Props {
  slice: PageSlice;
}

const CertificatesSlice: React.FC<Props> = () => {
  return (
    <Wrapper>
      <Certifications />
    </Wrapper>
  );
};

export default CertificatesSlice;

const Wrapper = styled.div``;
